export default "__VITE_ASSET__BrKT7Hlz__"